// extracted by mini-css-extract-plugin
export default {"inner":"style_inner__tA+Yw","controls":"style_controls__eMlcD","controlsHidden":"style_controlsHidden__blwaB"};